import { SyntheticEvent, useEffect, useState } from "react";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { Agendamento } from "../../../services/Agendamento";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  IAgendamentoDTO,
  IReembolsoConfirmarForm,
} from "../../../types/agendamento";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import dayjs from "dayjs";
import { IFaturaDTO } from "../../../types/pagamento";
import { Pagamento } from "../../../services/Pagamento";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";

export interface IModalReembolsoProps {
  isOPen: boolean;
  date?: Date;
}

export const useFormScheduleDetail = () => {
  const { setIsLoad } = useContextSite();
  const [searchParams, setSearchParams] = useSearchParams();
  let uuidAgendamento = searchParams.get("id");
  const [modalReembolso, setModalReembolso] = useState<IModalReembolsoProps>({
    isOPen: false,
  });
  const [agendamento, setAgendamento] = useState<IAgendamentoDTO>(
    {} as IAgendamentoDTO,
  );
  const [fatura, setFatura] = useState<IFaturaDTO>({} as IFaturaDTO);
  const navigate = useNavigate();

  function downloadLaudo() {
    if (!agendamento?.uuid) return;
    setIsLoad(true);
    Agendamento.downloadLaudo({ uuid: agendamento.uuid })
      .catch(() => toast.error("Erro ao baixar o laudo"))
      .finally(() => setIsLoad(false));
  }

  const getFatura = () => {
    Pagamento.consultarFatura({ uuidAgendamento })
      .then(({ data }) => {
        const value = data?.content?.find(
          (f) => f.status === StatusPagamentoEnum.pending,
        );
        setFatura(value);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem),
      );
  };

  function cancelarAgendamento() {
    setIsLoad(true);
    Agendamento.cancelar({ uuid: agendamento?.uuid })
      .then(({ data }) => {
        if (data?.encaminharFormulario) {
          setTimeout(() => {
            navigate(
              `/agendamento/${agendamento?.uuid}/pagamento/formulario-reembolso`,
            );
          }, 1500);
        }
        if (data?.confirmarReembosloPix) {
          navigate(`/agendamento/pagamento/cancelamento-pix`);
        }
        toast.success("Agendamento cancelado com sucesso");
        setTimeout(() => {
          navigate(`/meus-agendamentos/agendamento?id=${agendamento?.uuid}`);
        }, 1500);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem),
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function confirmarReembolso(e: SyntheticEvent) {
    e.preventDefault();
    setIsLoad(true);
    const PAYLOAD: IReembolsoConfirmarForm = {
      uuid: uuidAgendamento,
      dataDevolucao: dayjs(modalReembolso?.date).toISOString(),
    };

    Agendamento.confirmarReembolso(PAYLOAD)
      .then(({ data }) => {
        setAgendamento(data);
        toast.success("Reembolso confirmado");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem),
      )
      .finally(() => {
        setIsLoad(false);
        setModalReembolso({ isOPen: false, date: null });
      });
  }

  function getAgendamento() {
    if (!uuidAgendamento) return;
    setIsLoad(true);
    Agendamento.getById({ uuid: uuidAgendamento })
      .then(({ data }) => setAgendamento(data))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem),
      )
      .finally(() => setIsLoad(false));
  }

  useEffect(() => {
    if (uuidAgendamento) {
      getAgendamento();
      getFatura();
    }
  }, [uuidAgendamento]);

  const menuDisabled = [
    StatusAgendamentoEnum.CANCELADO,
    StatusAgendamentoEnum.INICIADO,
    StatusAgendamentoEnum.FINALIZADO,
  ].includes(agendamento?.status);

  function acessarFatura() {
    fatura?.pix?.qrcodeText !== null
      ? navigate(`/agendamento/${uuidAgendamento}/fatura`)
      : window.open(`${fatura?.url}.pdf`, "_blank");
  }

  function confirmarPagamento() {
    setIsLoad(true);
    Agendamento.confirmarPagamento({ uuid: uuidAgendamento })
      .then(({ data }) => setAgendamento(data))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem),
      )
      .finally(() => setIsLoad(false));
  }

  function retornarStatusIniciado() {
    setIsLoad(true);
    Agendamento.retornarStatusIniciado({ uuid: uuidAgendamento })
      .then(({ data }) => setAgendamento(data))
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem),
      )
      .finally(() => setIsLoad(false));
  }

  return {
    confirmarPagamento,
    retornarStatusIniciado,
    acessarFatura,
    agendamento,
    menuDisabled,
    cancelarAgendamento,
    confirmarReembolso,
    modalReembolso,
    setModalReembolso,
    fatura,
    downloadLaudo,
    getAgendamento,
  };
};
